/* TCI TERASHITA ADD FILE */

window.addEventListener('load', function() {
	validToken();
})

function setProductHandle() {
	var productHandle = window.location.pathname.match(".+/(.+?)([\?#;].*)?$")[1];
	localStorage.setItem('currentProduct', productHandle);
	console.log('called!')
	return true;
}

async function validToken() {
	var buyFlg = false;

	for (let i = 0; i < productMetaFields.length; i++) {
		var key = productMetaFields[i];
		var token = localStorage.getItem(key);

		if (token != null) {
			var params = 'permanentDomain=' + encodeURIComponent(permanentDomain) + '&token=' + encodeURIComponent(token) + '&settingId=' + encodeURIComponent(key.replace(/[^0-9]/g, ''));

			await fetch('https://verify.avex-shop.jp/fc_auth/valid_token?' + params, {
				method: 'GET'
			}).then(function(response) {
				return response.json();
			}).then(function(json) {
				if (json['result'] === 'OK') {
					buyFlg = true;
				} else {
					buyFlg = false;
				}
			}).catch(function(response) {
				buyFlg = false;
			});

			if (buyFlg == true) {
				var inputTokenElement = document.getElementById('fc-member-token');
				inputTokenElement.value = token;
				break;
			}
		}
	}

	if (buyFlg) {
		visibleBuyButton();
	} else {
		visibleFunClubLoginButton();
	}
}

// buyボタンを検索する(テーマに応じて変更が必要)
function getBuyButtons(){
  //var buyButtons = document.querySelectorAll('.product-form__add-button,.shopify-payment-button');
  var buyButtons = document.querySelectorAll('.paymentButtonsWrapper');
  return buyButtons;
}


function visibleBuyButton() {
	var buyButtonWrapperElement = document.getElementById('buy-button-wrapper');
  
    // buy-button-wrapper が定義されていない場合は、getBuyButtonsで対象を探し出す
    if(buyButtonWrapperElement){
    	buyButtonWrapperElement.style.display = 'block';
    }else{
		var buyButtons = getBuyButtons();
		buyButtons.forEach(function(target) {
			target.style.display = 'initial';
		});
    }
}

function visibleFunClubLoginButton() {
	var buyButtonWrapperElement = document.getElementById('buy-button-wrapper');
    var loginMessage = document.getElementById('fc-login-mesage');

    // buy-button-wrapper が定義されていない場合は、getBuyButtonsで対象を探し出す
    if(buyButtonWrapperElement){
    	while (buyButtonWrapperElement.firstChild) {
    		buyButtonWrapperElement.removeChild(buyButtonWrapperElement.firstChild);
    	}
    }else{
		var buyButtons = getBuyButtons();
		buyButtons.forEach(function(target) {
			//target.remove();
		});      
    }

	if (productMetaFields.length == 1) {
		var anchorLink = document.querySelectorAll('.link-area > a');
		anchorLink.forEach(function(target) {
			var id = target.id;
			var settingId = id.replace('fc-login-btn', '');

			if (productMetaFields[0] == 'setting' + settingId) {
				target.style.display = 'flex';
                if(loginMessage){
                  loginMessage.style.display = 'initial';
                }
			}
		});
	} else if (productMetaFields.length > 1) {
		var anchorLink = document.querySelectorAll('.link-area > a');
		anchorLink.forEach(function(target) {
			var id = target.id;
			var settingId = id.replace('fc-login-btn', '');
            var targetSettingPair = settingId.split("_");

            var productMetaFieldsPair = new Array();
            for(let i=0;i<productMetaFields.length;i++){
              productMetaFieldsPair[i] = productMetaFields[i].replace('setting','');
            }

			if (targetSettingPair.toString() == productMetaFieldsPair.toString()) {
				target.style.display = 'flex';
                if(loginMessage){              
                  loginMessage.style.display = 'initial';
                }
			}
		});
	}
}
